import { useState } from "react";
import { AssistantOverlay } from "../components/AssistantOverlay";

export default function AssistantFab({
  contextLabel,
}: {
  contextLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  if (open) return <AssistantOverlay onClose={() => setOpen(false)} contextLabel={contextLabel} />;

  return (
    <button
      onClick={() => setOpen(true)}
      className="fixed right-6 bottom-6 flex items-center gap-2 bg-ink-900 text-on-dark-bright text-[13.5px] font-semibold pl-3 pr-4 py-2 rounded-full shadow-fab hover:bg-ink-850"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8 1v3M8 12v3M1 8h3M12 8h3M3 3l2 2M11 11l2 2M3 13l2-2M11 5l2-2"
          stroke="#8FD8BC" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      Ask Daybrief
    </button>
  );
}
